import React from 'react';
import { Form, Input, Button } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { MinimalLayout } from '../../layouts';
import AppTheme from '../../theme/AppTheme';
import { Link } from 'react-router-dom';

const ForgotPassword = (props) => {
    const onFinish = values => {
        console.log('Received values of form: ', values);
    };
    return <MinimalLayout>
        <h1 style={{ color: AppTheme.colors.primary }} className="font-thin text-2xl pb-4">Forgot password</h1>
        <div className="bg-white shadow-sm p-8 inline-block">
            <p className="pb-3 whitespace-pre-wrap">Enter your email and you will receive <br /> somes instructions.</p>
            <Form
                name="normal_login"
                className="login-form"
                initialValues={{ remember: true }}
                onFinish={onFinish}
            >
                <Form.Item
                    name="username"
                    rules={[{ required: true, message: 'Please input your email!' }]}
                >
                    <Input type="email" prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Email" />
                </Form.Item>

                <Form.Item>
                    <Button type="primary" htmlType="submit" className="w-full">Reset my password</Button>
                    <div className="py-3"><Link to="/login">login now!</Link></div>
                </Form.Item>
            </Form>
        </div>
    </MinimalLayout>
}

export default ForgotPassword;